import type { Assistant } from "@inrev/assistant";
import { Option } from "@inrev/core";

/** Past the API's 45s for title generation, with slack for clock skew between client and server. */
const TITLE_PENDING_MS = 2 * 60_000;

export const TITLE_POLL_INTERVAL_MS = 2_000;
export const TITLE_POLL_MAX_MS = 50_000;

/**
 * The first complete answer landed recently and its generated title has not been written yet. The
 * API titles a conversation only from that answer, so interrupted-only, failed, and older
 * conversations never get one and are not worth polling for.
 */
export const needsGeneratedTitle = (
	conversation: Option<Pick<Assistant.Dtos.Conversation.Get.Response, "title" | "messages">>,
	nowMs: number = Date.now(),
): boolean => {
	if (Option.isNone(conversation) || Option.isSome(conversation.title)) return false;

	const firstCompleteAnswer = conversation.messages.find(
		(message) => message.role === "assistant" && Option.isNone(message.interruptedCode),
	);
	return Option.mapOrElse(
		firstCompleteAnswer,
		(answer) => nowMs - Date.parse(answer.createdAt) < TITLE_PENDING_MS,
		false,
	);
};
